import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router';

export default class AuthenticatedPslfFormOverviewRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    this.router.transitionTo('authenticated.pslf.dashboard.index');
  }
}
